import { supabase } from './supabaseClient';

// Marks a task done or reopens it. Marking done goes through public.crew_mark_task_done(), which also
// creates the next occurrence of a recurring task: same day of the month as the series' anchor,
// clamped to shorter months (Jan 31 -> Feb 28/29 -> Mar 31), keeping the assignee. One rule for every
// role and screen, kept in the database.
// Returns { error, nextTaskId, nextDueDate }.
export async function setTaskDone(task, done) {
  if (done) {
    const { data, error } = await supabase.rpc('crew_mark_task_done', { p_task: task.id });
    if (error) return { error };
    return { error: null, nextTaskId: data?.next_task_id || null, nextDueDate: data?.next_due_date || null };
  }
  const { error } = await supabase
    .from('tasks')
    .update({ done: false, updated_at: new Date().toISOString() })
    .eq('id', task.id);
  return { error, nextTaskId: null, nextDueDate: null };
}
